import { cls } from 'tagged-classnames-free';
export const fluentFlexItemClassName = cls`flex w-full overflow-auto xl:flex-1`
